export default {
  primary: "#16CF86",
  secondary: "#424242",
  accent: "#ee44aa",
  error: "#FF5252",
  info: "#2196F3",
  success: "#4CAF50",
  warning: "#FFC107",
  "button-primary": "#22CD6A"
};
